import React from 'react';
import { ChevronDown } from 'lucide-react';

const HeroSection: React.FC = () => {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-screen flex items-center" style={{
      backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://images.pexels.com/photos/4009346/pexels-photo-4009346.jpeg?auto=compress&cs=tinysrgb&w=1600')",
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }}>
      <div className="container mx-auto px-4 text-center text-white">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 leading-tight animate-fade-in">
          Redefine Your Journey:<br />Discover ECORIDE Electric Bicycles
        </h1>
        <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto animate-fade-in-delay">
          Exceptional range, powerful performance, and stunning design for an unmatched urban riding experience.
        </p>
        <div className="flex flex-col md:flex-row justify-center gap-4 mb-12 animate-fade-in-delay-2">
          <button 
            onClick={() => scrollToSection('contact')}
            className="bg-accent hover:bg-accent-dark text-white font-bold py-3 px-8 rounded-full text-lg transition-all hover:scale-105"
          >
            Book a Test Ride
          </button>
          <button 
            onClick={() => scrollToSection('models')}
            className="bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white font-bold py-3 px-8 rounded-full text-lg transition-all border border-white/30"
          >
            Explore Models
          </button>
        </div>
        <div className="absolute bottom-8 left-0 right-0 flex justify-center animate-bounce">
          <button 
            onClick={() => scrollToSection('features')}
            className="text-white"
            aria-label="Scroll down"
          >
            <ChevronDown size={32} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;